/**
 * Validates and auto-corrects company codes for edge function calls.
 * Los Banos and Madera location codes need to be prefixed with "FF" to match
 * the company codes in the database.
 * 
 * @param companyCode - The company code from PIN session or other source
 * @param source - Optional identifier for logging purposes (e.g., component name)
 * @returns The validated/corrected company code
 */
export function validateCompanyCode(companyCode: string | undefined, source?: string): string {
  if (!companyCode) {
    console.error(`⚠️ [${source || 'validateCompanyCode'}] No company code provided`);
    return '';
  }

  // Normalize to uppercase for case-insensitive comparison
  const normalizedCode = companyCode.toUpperCase();

  // Auto-correct location codes to company codes (case-insensitive)
  // MUST match the mapping in edge functions AND the actual company codes in database
  const locationToCompanyMap: Record<string, string> = {
    'LOSBANOS': 'FRESHFILL2026',
    'MADERA': 'FRESHFILL2026',
    'FFLOSBANOS': 'FRESHFILL2026',
    'FFMADERA': 'FRESHFILL2026',
  };

  const correctedCode = locationToCompanyMap[normalizedCode];

  if (correctedCode) {
    console.warn(`⚠️ [${source || 'validateCompanyCode'}] Company code is location code: ${companyCode}`);
    console.warn(`✅ [${source || 'validateCompanyCode'}] Auto-corrected to: ${correctedCode}`);
    return correctedCode;
  }

  // Return the normalized code - let the backend validate if it exists
  console.log(`✅ [${source || 'validateCompanyCode'}] Using company code: ${normalizedCode}`);
  return normalizedCode;
}
